import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import Typography from '@components/basics/typography';

interface NoDecorationProps {
  className?: string;
  text: React.ReactNode;
}

const NoDecoration: FunctionComponent<NoDecorationProps> = ({
  className,
  text,
}) => {
  return (
    <div className={className || ''}>
      <Text>{text}</Text>
    </div>
  );
};

export default styled(NoDecoration)`
  border: 1px dashed ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  width: 110px;
  height: 110px;
  aspect-ratio: 1 / 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-inline: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 150px;
    height: 150px;
  }
`;

const Text = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.small};
  color: ${({ theme }) => theme.colors.tertiary};
  text-align: center;
  user-select: none;
`;
